export const FETCH_MENU_SUCCESS = 'FETCH_MENU_SUCCESS';
export const FETCH_MENU_INIT = 'FETCH_MENU_INIT';

export const FETCH_SEARCH_TEXT_INIT = 'FETCH_SEARCH_TEXT_INIT';
export const FETCH_SEARCH_TEXT_SUCCESS = 'FETCH_SEARCH_TEXT_SUCCESS';

export const FETCH_PRODUCT_INIT = 'FETCH_PRODUCT_INIT';
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS';
